<template>
  <div class="catalogs-resolutions-content">
    <div v-if="$route.path.includes('edit') || $route.path.includes('create')" class="sub-header">
      <b-container fluid>
        <appCatalogsNav
          v-if="$route.path.includes('create')"
          :title="titleCreate"
          :breadcrumb-last="breadcrumbLastCreate"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
        <appCatalogsNav
          v-else-if="$route.path.includes('edit')"
          :title="titleEdit"
          :breadcrumb-last="breadcrumbLastEdit"
          :breadcrumb-route-text="breadcrumbRouteText"
          :breadcrumb-route-name="breadcrumbRouteName"
        />
      </b-container>
    </div>

    <b-container fluid>
      <div v-if="!$route.path.includes('edit') && !$route.path.includes('create')">
        <b-container>
          <b-button
            class="button btn-blue my-4 fw-600"
            :to="{ name: 'create-resolutions-catalog' }"
          >
            <font-awesome-icon icon="plus" class="agv-button-icon" />
            <span>{{ $t("catalogs.resolutions_create") }}</span>
          </b-button>
        </b-container>

        <b-container>
          <appResolutionsCatalogTable></appResolutionsCatalogTable>
        </b-container>
      </div>

      <router-view />
    </b-container>
  </div>
</template>

<script>
import appCatalogsNav from "@/components/snippets/CatalogsNav";

import ResolutionCatalogMW from "@/middlewares/ResolutionCatalog";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";

import mercureMixin from "@/mixins/mercure-live-changes/resolution-catalogs";

export default {
  components: {
    appCatalogsNav,
    appResolutionsCatalogTable: () =>
      import("@/components/catalogs/resolutions/ResolutionsCatalogTable"),
  },
  mixins: [mercureMixin],
  data() {
    return {
      titleCreate: this.$t("catalogs.resolutions_create"),
      breadcrumbLastCreate: this.$t("general.create"),
      titleEdit: this.$t("catalogs.resolutions_edit"),
      breadcrumbLastEdit: this.$t("general.edit"),
      breadcrumbRouteText: this.$t("catalogs.resolutions"),
      breadcrumbRouteName: "resolutions-catalogs",
      ResolutionCatalogMW: ResolutionCatalogMW,
      ResolutionCatalogORM: ResolutionCatalogORM,
    };
  },
};
</script>
